import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import GridItem from "components/Grid/GridItem.jsx";


import {
  AcUnit,
  Whatshot,
  LocalCarWash,
  Build,
  Phone,
  PermDataSetting,
  Security,
  Layers
} from "@material-ui/icons";



import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";

import SectionCarousel from "./SectionCarousel.jsx";


class SectionService extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <h3 className={classes.title}> Mechanical  &  Electrical Engineering Services</h3>
        <SectionCarousel />
          
         <div className={classes.section}>
          <GridContainer justify="center">
      
          <GridItem xs={12} sm={12} md={8}>
            <h5 className={classes.description}>
              Our established team specializes in a wide range of lifts and
              escalator, Security Systems such as CCTV, Audio/Video Intercom,
              Card Access System, Automatic Vehicular Access System, Full/Semi
              Electronic Parking System, Intrusion Detection System and Wireless
              Guard Tour System.
            </h5>
          </GridItem>
        </GridContainer>
        </div>
        <br />
       
            <GridContainer justify="center">
             <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}> Mechanical Engineering Services</h2>
          </GridItem>
          </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Air-Conditioning & Mechanical Ventilation System (ACMV)"
              description="Our expertise and focus on M&E services in trending building services include Air-Condition & Mechanical Ventilation (ACMV) System such as Chilled Water System Design, Unitary Air-Condition System, Carpark Ventilation System, Smoke Purging System, Pressurization System for staircase, smoke stop lobby and Kitchen Exhaust System."
              icon={AcUnit}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Sanitary Plumbing System & Water Service"
              description="We also specialize in Sanitary Plumping System and Water Services, full range of Fire Protection System for residential, commercial and industrial buildings."
              icon={Build}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Power System Analysis & Design"
              description="Our dedicated team is ready to deliver reliable services related to Power System Analysis such as Short Circuit Study, Load Flow Study and Relay Coordination Study, Electrical Substation Design and Layout, sizing of Transformer, Medium/Low Voltage Switchgears, Generators and Uninterruptible Power Supply (UPS), details design for Lighting and Load Distribution System, Earthing and Lightning Protection System, Building Management System (BMS), and Essential, Critical Power and Cooling System design for Data Center, Banks, Hospitals and airports."
              icon={Whatshot}
              iconColor="info"
              vertical
            />
          </GridItem>
        </GridContainer>
        <br />
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <h3 className={classes.title}>
              Air-Conditioning & Mechanical Ventilation System (ACMV)
            </h3>
            <h5 className={classes.desc}>
              We provide Cooling Load Estimation, Chilled Water System Design,
              Chiller, Cooling Tower, Pumps & Pipe Sizing, Unitary
              Air-Conditioning System Split, Multi-Split & VRF System, Air
              Change Calculation, Duct Size Calculation, Carpark Ventilation
              System, Smoke Purging System, Pressurization System for Staircase
              and Smoke Stop Lobby and Kitchen Exhaust System.
            </h5>

          </GridItem>
        </GridContainer>
        <br />
        <GridContainer justify="center">
         <GridItem xs={12} sm={12} md={4}>
          <h3 className={classes.title}>
              Sanitary Plumbing System & Water Service
            </h3>
            <h5 className={classes.desc}>
              We provide Sanitary and Waste Drainage System, Water Distribution
              System ,Sewerage Treatment System and Domestic Water Treatment
              System.
            </h5>
          </GridItem>
        </GridContainer>
        <br />

        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
          
            <h3 className={classes.title}>Fire Protection System</h3>
            <h5 className={classes.desc}>
              We provide Automatic/Manual Fire Alarm System, Dry/Wet Riser
              System, Fire Hosereel System and Hydrant System.
            </h5>

          </GridItem>
        </GridContainer>
        <br />
      <hr />
        <br />
        <h2 className={classes.title}> Electrical Engineering Services</h2>
     
        <GridContainer justify="center">

          <GridItem xs={12} sm={12} md={8}>
              <h5 className={classes.description}>
              Our team provides Electrical Systems, Telephone, Data & Television
              System, Vertical Transportation System, Security Systems and
              Emergency Voice Communication System/Public Address System.
            </h5>
          </GridItem>
        </GridContainer>

        <br />

        <br />
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Electrical Systems"
              description="Our expertise and focus on M&E services in Power System Study (Short Circuit, Load Flow & Relay Coordination), Sizing of Transformer, MV/LV Switchgears, Generator & UPS, Electrical Load Calculation & Setting Schedule , Voltage Drop & Cable Size Calculation ,Electrical Substation Design & Equipment Layout, Electrical Supply and Load Distribution System Design, Lighting Illumination & Efficiency Calculation, Detailed Lighting and Power Layout Plan, Earthing & Lightning Protection System, Building Management System (BMS)."
              icon={PermDataSetting}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Security Systems"
              description="We also specialize in Closed Circuit Television System, Audio/Video Intercom, Card Access System, Automatic Vehicular Access System, Full/Semi Electronic Parking System, Intrusion Detection System, Wireless Guard Tour System."
              icon={Security}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Vertical Transportation System"
              description="We provide Passenger/Fire/Cargo Lift, Escalator"
              icon={LocalCarWash}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <InfoArea
              title="Emergency Voice Communication System/Public Address System"
              description="We provide Emergency Voice Communication System/Public Address System."
              icon={Layers}
              iconColor="danger"
              vertical
            />
            <br />
            <br />
            <br />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <InfoArea
              title="Telephone, Data & Television System"
              description="We also provide Telephone, Data & Television System."
              icon={Phone}
              iconColor="danger"
              vertical
            />
            <br />
            <br />
            <br />
          </GridItem>
        </GridContainer>
        </div>
    );
  }
}

export default withStyles(workStyle)(SectionService);



// WEBPACK FOOTER //
// ./src/views/MechPage/Sections/SectionService.jsx